import * as React from 'react'
import './Card.scss'

interface ICardProps {
  className?: string
  children: React.ReactNode
}

export class Card extends React.PureComponent<ICardProps> {
  BEM = () => {
    const { className } = this.props

    const classArray = ['card']

    if (className) {
      classArray.push(className)
    }

    return classArray.join(' ')
  }

  render() {
    return <div className={this.BEM()}>{this.props.children}</div>
  }
}
